var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],domProps:{"value":(_vm.internalValue)},on:{"keydown":_vm.onKeyDown,"input":function($event){if($event.target.composing)return;_vm.internalValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }